export default __webpack_public_path__ + "static/media/sf-logo-white.27a902a9.png";